import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from './HomePage';
// import StatsFacts from "./home/StatsFacts";
import Aboutus from "./home/AboutUs";
import Team from "./home/Team";
import Contact from "./home/Contact";

function App() {
  return (
    <>
        <Router>
            <Routes>
              <Route path='/' element={<Navigate to="/home" replace />}/>
              <Route path='/home' element={<HomePage/>}/>
              <Route path="/about" element={<Aboutus/>}/>
              <Route path="/team" element={<Team/>}/>
              <Route path="/contact" element={<Contact/>}/>
            </Routes>
        </Router>
    </>
  );
}

export default App;
